import React from "react";
import { Row, Col, Card, Avatar } from "antd";
import AvatarPersona1 from "../../../assets/img/jpg/08a28a6e53f4279d0fccb2a9d7b6d4df.jpg";
import AvatarPersona2 from "../../../assets/img/jpg/58a9177f55a0783b2b9446d93ae268df.jpg";
import AvatarPersona3 from "../../../assets/img/jpg/b74acd489a754d949d24a279bc1a44e6.jpg";
import AvatarPersona4 from "../../../assets/img/jpg/e25fc5cb26785071c5c06518edb7d470.jpg";
import AvatarPersona5 from "../../../assets/img/png/ironman-head-comics-avatar-iron-man-512.png";

import "./ReviewsCourses.scss";

export default function ReviewsCourses() {
  return (
    <Row className="reviews-courses">
      <Row>
        <Col lg={4} />
        <Col lg={16} className="reviews-courses__title">
          <h2>
            Forma parte de los +35 mil estudiantes que estan aprendiendo con mis
            cursos.
          </h2>
        </Col>
        <Col lg={4} />
      </Row>
      <Row>
        <Col lg={4} />
        <Col lg={16}>
          <Row className="row-cards">
            <Col md={8}>
              <CardReview
                name="Alonso Campos"
                subtitle="Alumno de Udemy"
                avatar={AvatarPersona1}
                review="Un curso excelete, el profesor explica detalladamente como functiona react native y también como hacer componente por componente, he buscado muchos curso de react native pero ninguno me ha enseñado tanto como este, ahora estoy desarrollando mi propia aplicación sin ningún tipo de problema gracias al curso."
              />
            </Col>
            <Col md={8}>
              <CardReview
                name="David Ramiro"
                subtitle="Alumno de Udemy"
                avatar={AvatarPersona2}
                review="Si te gustan los cursos que profundizan la materia, te lo recomiendo. El profesosr explica de forma completa todos los conceptos necesarios para trabajar con grid. Un gran curso."
              />
            </Col>
            <Col md={8}>
              <CardReview
                name="Valentina Rubio"
                subtitle="Alumna de Udemy"
                avatar={AvatarPersona3}
                review="El contenido del curso es muy completo y de necesitar culquier dato adicional, el profesor esta super pendiente para responderlo. Ya tengo creado mi E-commerce con WordPress y gran parte de la información necesaria la obtuve del curso."
              />
            </Col>
          </Row>
          <Row className="row-cards">
            <Col md={8}>
              <CardReview
                name="Marco Perez"
                subtitle="Alumno de Udemy"
                avatar={AvatarPersona4}
                review="Un curso excelete, el profesor explica detalladamente como functiona react native y también como hacer componente por componente, he buscado muchos curso de react native pero ninguno me ha enseñado tanto como este, ahora estoy desarrollando mi propia aplicación sin ningún tipo de problema gracias al curso."
              />
            </Col>
            <Col md={8}>
              <CardReview
                name="Jesus Cruz"
                subtitle="Alumno de Udemy"
                avatar={AvatarPersona5}
                review="Si te gustan los cursos que profundizan la materia, te lo recomiendo. El profesosr explica de forma completa todos los conceptos necesarios para trabajar con grid. Un gran curso."
              />
            </Col>
            <Col md={8}>
              <CardReview
                name="Francisco Garcia"
                subtitle="Alumna de Udemy"
                avatar={AvatarPersona1}
                review="El contenido del curso es muy completo y de necesitar culquier dato adicional, el profesor esta super pendiente para responderlo. Ya tengo creado mi E-commerce con WordPress y gran parte de la información necesaria la obtuve del curso."
              />
            </Col>
          </Row>
        </Col>
        <Col lg={4} />
      </Row>
    </Row>
  );
}

function CardReview(props) {
  const { name, subtitle, avatar, review } = props;
  const { Meta } = Card;

  return (
    <Card className="reviews-courses__card">
      <p>{review}</p>
      <Meta
        avatar={<Avatar src={avatar} />}
        title={name}
        description={subtitle}
      />
    </Card>
  );
}
